import { ReactElement, useCallback, useContext, useEffect, useState } from 'react';
import aiStyles from '@/styles/pages/admin/ai.module.less';
import { getConversations } from '@/services/api/ai';
import { AiComponentContext } from '@/context';

// Type assertion to fix CSS module typing issue
const MessageHistory = (): ReactElement => {
    const [messageHistory, setMessageHistory] = useState<MessageConversation[]>([]);
    const { setOpenHistory, setConversationId } = useContext(AiComponentContext);
    const init = useCallback(async () => {
        const data = await getConversations();
        setMessageHistory(data);
    }, []);

    const handelConversation = useCallback((conversationId: string) => {
        setConversationId(conversationId);
        setOpenHistory(false);
    }, []);

    useEffect(() => {
        init();
    }, [init]);

    return (
        <div className={aiStyles['message-history']}>
            {messageHistory.map((item) => (
                <div onClick={() => handelConversation(item.conversationId)} className={aiStyles['message-history-item']} key={item.conversationId}>
                    {item.title}
                </div>
            ))}
        </div>
    );
};

export default MessageHistory;
